// src/features/quality/routes.tsx
// ADR-091 Rule QC-FE-08. Consumed by src/routes/router.tsx (Aggregator,
// ADR-072 Rule FMS-03) — that file was not read in this session; add the
// import + spread there manually, do not rewrite router.tsx wholesale.

import type { RouteObject } from "react-router-dom";

import { QualityHomePage } from "./pages/QualityHomePage";
import { QualityCheckFamiliesPage } from "./pages/QualityCheckFamiliesPage";
import { QualityCheckFamilyDetailPage } from "./pages/QualityCheckFamilyDetailPage";
import { QualityCheckRevisionCreatePage } from "./pages/QualityCheckRevisionCreatePage";
import { QualityCheckRevisionDetailPage } from "./pages/QualityCheckRevisionDetailPage";
import { InspectionRecordsPage } from "./pages/InspectionRecordsPage";
import { InspectionRecordCreatePage } from "./pages/InspectionRecordCreatePage";

import { QualityHomePageHelpPage } from "./pages/help/QualityHomePageHelpPage";
import { QualityCheckFamiliesPageHelpPage } from "./pages/help/QualityCheckFamiliesPageHelpPage";
import { InspectionRecordsPageHelpPage } from "./pages/help/InspectionRecordsPageHelpPage";
import { InspectionRecordCreatePageHelpPage } from "./pages/help/InspectionRecordCreatePageHelpPage";
import QualityCheckFamilyDetailHelp from "./help/quality-check-family-detail.mdx";
import QualityCheckRevisionCreateHelp from "./help/quality-check-revision-create.mdx";
import QualityCheckRevisionDetailHelp from "./help/quality-check-revision-detail.mdx";

export const qualityRoutes: RouteObject[] = [
  { path: "quality", element: <QualityHomePage /> },
  { path: "quality/families", element: <QualityCheckFamiliesPage /> },
  {
    path: "quality/families/:familyId",
    element: <QualityCheckFamilyDetailPage />,
  },
  {
    path: "quality/families/:familyId/revisions/new",
    element: <QualityCheckRevisionCreatePage />,
  },
  {
    path: "quality/revisions/:revisionId",
    element: <QualityCheckRevisionDetailPage />,
  },
  { path: "quality/inspections", element: <InspectionRecordsPage /> },
  {
    path: "quality/inspections/new",
    element: <InspectionRecordCreatePage />,
  },
  { path: "help/quality/quality-home", element: <QualityHomePageHelpPage /> },
  { path: "help/quality/quality-check-families", element: <QualityCheckFamiliesPageHelpPage /> },
  { path: "help/quality/inspection-records", element: <InspectionRecordsPageHelpPage /> },
  { path: "help/quality/inspection-record-create", element: <InspectionRecordCreatePageHelpPage /> },
  { path: "help/quality/quality-check-family-detail", element: <QualityCheckFamilyDetailHelp /> },
  { path: "help/quality/quality-check-revision-create", element: <QualityCheckRevisionCreateHelp /> },
  { path: "help/quality/quality-check-revision-detail", element: <QualityCheckRevisionDetailHelp /> },
];
